<template>
  <article class="brand-store-tile" @click.prevent="$emit('open-modal')">
    <!-- Title -->
    <h2 class="h4 title mb-3">
      <a :href="brand.get_absolute_url" @click.prevent>
        {{ brand.brand_name }}
      </a>
    </h2>

    <!-- About brand -->
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="brand.about_brand_stripped_and_limited != 'None'"
      class="text mb-2"
      v-html="brand.about_brand_stripped_and_limited"
    />

    <!-- Tags -->
    <div v-if="brand.tag_mappings_all_products" class="tags mb-2">
      <ul>
        <li v-for="tagmapping in tags" :key="tagmapping.id">
          {{ tagmapping.tag.display_name }}
        </li>
        <li
          v-if="
            !showMore && brand.tag_mappings_all_products.length > maxInitialTags
          "
        >
          ...
        </li>
        <li
          v-if="
            !showMore && brand.tag_mappings_all_products.length > maxInitialTags
          "
          class="show-more"
        >
          <a href="#" @click.prevent.stop="showMore = true">
            {{ gettext('show more') }}
          </a>
        </li>
      </ul>
    </div>

    <!-- Certificates/labels -->
    <!-- eslint-enable vue/no-v-html -->
    <div
      v-if="
        (brand.labels && brand.labels.length > 0) ||
        (brand.certificate && brand.certificate.length > 0)
      "
      class="labels-and-certificates d-flex justify-content-between mt-auto pt-1"
    >
      <div
        v-if="brand.labels && brand.labels.length > 0"
        class="w-50 d-flex flex-column"
      >
        <span class="title">
          {{ gettext('Labels') }}
        </span>
        <div class="d-flex align-items-center justify-content-start flex-wrap">
          <span
            v-for="label in brand.labels"
            :key="label"
            class="cece-tooltip"
            :data-tooltip="labelsMap[label].label_name"
          >
            <img
              class="label-icon-img mb-1"
              :src="`/static/img/labels/${labelsMap[label].abbreviation}.png`"
            />
          </span>
        </div>
      </div>
      <div
        v-if="brand.certificate && brand.certificate.length > 0"
        class="w-50 d-flex flex-column"
      >
        <span class="d-block title text-end">
          {{ gettext('Certificates') }}
        </span>
        <div class="d-flex align-items-center justify-content-end flex-wrap">
          <span
            v-for="cert in brand.certificate"
            :key="cert.id"
            class="cece-tooltip"
            :data-tooltip="cert.name"
          >
            <img class="certificate-icon-img mb-1" :src="cert.static_url" />
          </span>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
const MAX_INITIAL_TAGS = 5;

export default {
  props: {
    brand: {
      type: Object,
      default: null,
    },
    labelsMap: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    tags() {
      return this.showMore
        ? this.brand.tag_mappings_all_products
        : this.brand.tag_mappings_all_products.slice(0, 5);
    },
    maxInitialTags() {
      return MAX_INITIAL_TAGS;
    },
  },
};
</script>
